import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private msg = inject(MessageService);

  success(detail: string, summary = 'Muvaffaqiyat') {
    this.msg.add({ severity: 'success', summary, detail, life: 3000 });
  }

  error(detail: string, summary = 'Xato') {
    this.msg.add({ severity: 'error', summary, detail, life: 5000 });
  }

  warn(detail: string, summary = 'Ogohlantirish') {
    this.msg.add({ severity: 'warn', summary, detail, life: 4000 });
  }

  info(detail: string, summary = "Ma'lumot") {
    this.msg.add({ severity: 'info', summary, detail, life: 3000 });
  }
}
